import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { settingsActions } from 'store/settings'
import { getAgentsParams } from 'api/agents'

/**
 * On chat open, asks the backend which runtime inputs the tenant's enabled agents
 * need (GET /agents/params). A non-empty result turns on agentic mode for the
 * chat; any failure degrades gracefully to plain RAG chat.
 */
export const useAgenticBootstrap = () => {
  const dispatch = useDispatch()
  const chatId = useSelector(messagesSelectors.chatId)

  useEffect(() => {
    if (!chatId) return

    let cancelled = false
    getAgentsParams(chatId)
      .then((requirements) => {
        if (!cancelled) {
          dispatch(settingsActions.setAgenticConfig({ enabled: requirements.length > 0, requirements }))
        }
      })
      .catch((e) => {
        console.error('[agentic] failed to load agents params', e)
        if (!cancelled) dispatch(settingsActions.setAgenticConfig({ enabled: false, requirements: [] }))
      })

    return () => {
      cancelled = true
    }
  }, [chatId, dispatch])
}
